import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import SvgFrame from './features/svg-container/SvgFrame';
import MainFrame from './features/main-frame/MainFrame';
import Error404 from './features/error-404/Error404';
import ErrorPermissionDenied from './features/error-permission/ErrorPermissionDenied';
import NotifyPasswordUpdate from './features/notify/NotifyPasswordUpdate';
import NotifyPermissionUpdate from './features/notify/NotifyPermissionUpdate';
import AuthComponent from './features/auth/AuthComponent';
import Privacy from './features/main-frame/components/Privacy';
import Copyright from './features/main-frame/components/Copyright';
import Contact from './features/main-frame/components/Contact';

import Login from './modules/login/LoginPage';

function App() {
  return (
    <Router>
        <SvgFrame />
        <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/copyright" element={<Copyright />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/module/*" element={(
                <AuthComponent>
                    <MainFrame />
                </AuthComponent>
            )} />
            <Route path="/permission-denied" element={<ErrorPermissionDenied />} />
            <Route path="/notify-password-update" element={<NotifyPasswordUpdate />} />
            <Route path="/notify-permission-update" element={<NotifyPermissionUpdate />} />
            <Route path="*" element={<Error404 />} />
        </Routes>
    </Router>
  );
}

export default App;
